/** Shopify CDN: Minification failed

Line 16:441 Transforming for-of loops to the configured target environment ("es5") is not supported yet
Line 16:503 Transforming const to the configured target environment ("es5") is not supported yet
Line 16:508 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 16:573 Transforming generator functions to the configured target environment ("es5") is not supported yet
Line 16:926 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 16:965 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 16:976 Transforming const to the configured target environment ("es5") is not supported yet
Line 16:1892 Transforming const to the configured target environment ("es5") is not supported yet
Line 16:2058 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 16:2061 Transforming const to the configured target environment ("es5") is not supported yet
... and 32 more hidden warnings

**/
(self.webpackChunkhappysoaps = self.webpackChunkhappysoaps || []).push([[5391], {
    663: (e,t,r)=>{
        var a = Object.defineProperty
          , s = Object.defineProperties
          , n = Object.getOwnPropertyDescriptors
          , o = Object.getOwnPropertySymbols
          , c = Object.prototype.hasOwnProperty
          , i = Object.prototype.propertyIsEnumerable
          , l = (e,t,r)=>t in e ? a(e, t, {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: r
        }) : e[t] = r
          , u = (e,t)=>{
            for (var r in t || (t = {}))
                c.call(t, r) && l(e, r, t[r]);
            if (o)
                for (var r of o(t))
                    i.call(t, r) && l(e, r, t[r]);
            return e
        }
          , d = (e,t)=>s(e, n(t));
        const {theme: m} = globalThis;
        function p() {
            return e = this,
            t = null,
            a = function*() {
                return void 0 === globalThis.Swal && (yield r.e(1216).then(r.bind(r, 2011)),
                globalThis.Swal = yield r.e(1216).then(r.t.bind(r, 6455, 23))),
                globalThis.Swal
            }
            ,
            new Promise(((r,s)=>{
                var n = e=>{
                    try {
                        c(a.next(e))
                    } catch (e) {
                        s(e)
                    }
                }
                  , o = e=>{
                    try {
                        c(a.throw(e))
                    } catch (e) {
                        s(e)
                    }
                }
                  , c = e=>e.done ? r(e.value) : Promise.resolve(e.value).then(n, o);
                c((a = a.apply(e, t)).next())
            }
            ));
            var e, t, a
        }
        class h extends HTMLElement {
            constructor() {
                super();
                const e = {
                    section: ".shopify-section-cart-drawer",
                    customElemetClassName: "cart-drawer",
                    close: "[data-close]",
                    cartBubble: "#cart-icon-bubble .products-in-cart",
                    backdrop: "[data-backdrop]",
                    btnAdd: '[name="add"]',
                    quantityInput: '[name="updates[]"]',
                    quantityInputIndexDataName: "data-index",
                    removeLineDataName: "data-remove-line",
                    cartItemsSizeAttributeName: "cart-items-size",
                    body: "body",
                    header: ".main-header",
                    headerWrapper: ".main-header__wrapper",
                    announcementBar: ".o-top-bar",
                    searchBar: ".main-items__search .a-input"
                };
                if (m.cartDrawer = h,
                m.cartDrawer.selectors = e,
                this.section = h.isExit(this.closest(e.section), e.section),
                this.close = h.isExit(this.querySelector(e.close), e.close),
                this.backdrop = h.isExit(this.section.querySelector(e.backdrop), e.backdrop),
                h.actionClose(),
                this.cartItemSize = Number(this.getAttribute(e.cartItemsSizeAttributeName)),
                this.cartItemSize > 0) {
                    h.isExit(this.section.querySelector(e.quantityInput), e.quantityInput);
                    const t = this.section.querySelectorAll(e.quantityInput);
                    h.quantityInputChangeListener(t),
                    h.removeCartItemClickListener()
                }
                h.setDrawerPosition()
            }
            static setDrawerPosition() {
                const e = h.isExit(document.querySelector(m.cartDrawer.selectors.header), m.cartDrawer.selectors.header)
                  , t = h.isExit(document.querySelector(m.cartDrawer.selectors.headerWrapper), m.cartDrawer.selectors.headerWrapper)
                  , r = h.isExit(document.querySelector(m.cartDrawer.selectors.announcementBar), m.cartDrawer.selectors.announcementBar)
                  , a = h.isExit(document.querySelector(m.cartDrawer.selectors.searchBar), m.cartDrawer.selectors.searchBar)
                  , s = h.isExit(document.querySelector(m.cartDrawer.selectors.customElemetClassName), m.cartDrawer.selectors.customElemetClassName)
                  , n = e ? e.offsetHeight : 0
                  , o = r ? r.offsetHeight : 0
                  , c = a ? a.offsetHeight - 2 : 0;
                let i = 0;
                const l = t.getBoundingClientRect().x + 16;
                i = window.innerWidth < 767 ? n + o + c : n + o,
                s.style.top = `${i}px`,
                s.style.right = `${l}px`
            }
            static quantityInputChangeListener(e) {
                if (0 === e.length)
                    throw Error("Unable to find quantityInputs param.");
                e.forEach((e=>{
                    e.addEventListener("change", (e=>{
                        const {quantityInputIndexDataName: t} = m.cartDrawer.selectors;
                        if (!e.target.hasAttribute(t))
                            throw Error(`Unable to find attribute ${t} of element.`);
                        const r = Number(e.target.getAttribute(t))
                          , a = Number(e.target.value);
                        Number.isNaN(r) || Number.isNaN(a) || m.cartDrawer.changeCart(r, a)
                    }
                    ))
                }
                ))
            }
            static isExit(e, t) {
                if (null == e)
                    throw Error(`Unable to find DOM element ${t}.`);
                return e
            }
            static actionClose() {
                const {cartDrawer: e} = m
                  , {selectors: t} = e
                  , r = e.isExit(document.querySelector(t.section))
                  , a = e.isExit(r.querySelector(t.close), t.close)
                  , s = e.isExit(document.querySelector(t.body), t.body);
                [a, e.isExit(r.querySelector(t.backdrop), t.backdrop)].forEach((e=>{
                    e.addEventListener("click", (e=>{
                        e.preventDefault(),
                        r.classList.add("close"),
                        r.classList.remove("open"),
                        s.classList.remove("block-scroll")
                    }
                    ))
                }
                )),
                this.updateBubbleQuantity(t, r)
            }
            static updateBubbleQuantity(e, t) {
                const r = [...t.querySelectorAll(e.quantityInput)].map((e=>Number(e.value))).reduce(((e,t)=>e + t), 0)
                  , a = document.querySelector(e.cartBubble);
                r > 0 && a ? (a.classList.contains("hidden") && a.classList.remove("hidden"),
                r !== Number(a.textContent.trim()) && (a.classList.add("updated"),
                setTimeout((()=>{
                    a.classList.remove("updated")
                }
                ), 600)),
                a.textContent = r) : 0 !== r || a.classList.contains("hidden") || a.classList.add("hidden")
            }
            static actionOpen() {
                const {selectors: e} = m.cartDrawer
                  , t = document.querySelector(e.section);
                document.querySelector(e.body).classList.add("block-scroll"),
                t.classList.remove("close"),
                t.classList.add("open"),
                setTimeout(() => {
                        FGSECOMAPP.renderPromotionMessage(FGSECOMAPP.offers);
                    }, 1000)  
            }
            static fetchConfig(e="json") {
                return {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Accept: `application/${e}`
                    }
                }
            }
            static getSectionInnerHTML(e, t) {
                return (new DOMParser).parseFromString(e, "text/html").querySelector(t).innerHTML
            }
            static updateCart(e, t="/cart/change.js") {
                return fetch(t, d(u({}, m.cartDrawer.fetchConfig()), {
                    body: JSON.stringify(d(u({}, e), {
                        sections: "cart-drawer"
                    }))
                })).then((e=>e.json())).then((e=>{
                    if (422 === e.status || "bad_request" === e.status)
                        throw e;
                    const {selectors: r} = m.cartDrawer
                      , a = m.cartDrawer.isExit(document.querySelector(r.section));
                    if (m.cartDrawer.isExit(a.querySelector(`.${r.customElemetClassName}`)).innerHTML = h.getSectionInnerHTML(e.sections[r.customElemetClassName], `.${r.customElemetClassName}`),
                    m.cartDrawer.actionClose(),
                    e.items.length > 0) {
                        const e = a.querySelectorAll(r.quantityInput);
                        m.cartDrawer.quantityInputChangeListener(e),
                        m.cartDrawer.removeCartItemClickListener()
                    }
                    return "/cart/add.js" === t && h.actionOpen(),
                    e
                }
                )).catch((e=>{
                    var t;
                    const r = (null == (t = null == e ? void 0 : e.description) ? void 0 : t.length) ? e.description : window.cartTranslates.addToCartError;
                    return p().then((e=>{
                        e.default.fire({
                            html: r,
                            toast: !0,
                            position: "top-end",
                            showConfirmButton: !1,
                            timer: 3e3,
                            timerProgressBar: !0,
                            showCloseButton: !0,
                            didOpen: t=>{
                                t.addEventListener("mouseenter", e.default.stopTimer),
                                t.addEventListener("mouseleave", e.default.resumeTimer)
                            }
                        })
                    }
                    )),
                    e
                }
                ))
            }
            static addToCart(e) {
                return h.updateCart({
                    items: e
                }, "/cart/add.js")
            }
            static changeCart(e, t) {
                return h.updateCart({
                    line: e,
                    quantity: t
                })
            }
            static removeCartItemClickListener() {
                const {removeLineDataName: e} = m.cartDrawer.selectors
                  , t = document.querySelectorAll(`[${e}]`);
                if (0 === t.length)
                    throw Error("Unable to find data-remove-line attributes.");
                t.forEach((t=>{
                    t.addEventListener("click", (t=>{
                        t.preventDefault();
                        const r = Number(t.target.getAttribute(e));
                        Number.isNaN(r) || h.updateCart({
                            line: r,
                            quantity: 0
                        })
                    }
                    ))
                }
                ))
            }
        }
        customElements.define("cart-drawer", h)
    }
}, e=>{
    var t;
    t = 663,
    e(e.s = t)
}
]);
